import { useState } from 'react'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid'
import { CheckCircleIcon, XCircleIcon, ArrowUturnLeftIcon, ForwardIcon } from '@heroicons/react/24/outline'

import ContentFrame from 'components/Frame/ContentFrame'
import UserProfilePicture from 'components/User/UserProfilePicture'

export default function GroupAttendance({ 
    groupAthleteAttendanceData,
    setGroupAthleteAttendanceData
}) {

    const tabs = [
        { key: 'present', text: 'Present', icon: <CheckCircleIcon className='h-6 w-6 text-green-500' /> },
        { key: 'absent', text: 'Absent', icon: <XCircleIcon className='h-6 w-6 text-red-500' /> },
        { key: 'complete', text: 'Complete', icon: <ForwardIcon className='h-6 w-6 text-gray-500' /> }
    ]

    const [selectedTab, setSelectedTab] = useState('present')
    const [restrictHeight, setRestrictHeight] = useState(true)

    const ViewAthleteProfileInNewTab = (athleteId) => {
        window.open(`/athlete/${athleteId}`, '_blank')
    }

    const ToggleAthleteAttendanceStatus = (athleteId) => {

        var newGroupAthleteAttendanceData = JSON.parse(JSON.stringify(groupAthleteAttendanceData))

        const athleteIndex = newGroupAthleteAttendanceData.findIndex((athlete) => athlete.id === athleteId)

        if (athleteIndex === -1) {
            console.error('Athlete with id ' + athleteId + ' not found')
            return
        }

        // console.log(newGroupAthleteAttendanceData[athleteIndex])

        if (newGroupAthleteAttendanceData[athleteIndex].attendanceStatus === 'present') {
            // console.log('present to absent')
            newGroupAthleteAttendanceData[athleteIndex].attendanceStatus = 'absent'
            setGroupAthleteAttendanceData(newGroupAthleteAttendanceData)
            return
        }

        if (newGroupAthleteAttendanceData[athleteIndex].attendanceStatus === 'absent') { 
            // console.log('absent to present')
            newGroupAthleteAttendanceData[athleteIndex].attendanceStatus = 'present'
            setGroupAthleteAttendanceData(newGroupAthleteAttendanceData)
            return
        }

    }

    // console.log(groupAthleteAttendanceData)

    return (
        <div className='space-y-4'>
            <p>Attendance</p>

            <ContentFrame>
                <div className='w-full grid grid-cols-3 divide-x divide-gray-200'>
                    {tabs.map((tab) => (
                        <div 
                            key={tab.key} 
                            className={`
                                flex items-center justify-center gap-x-2 p-4 cursor-pointer select-none
                                ${tab.key === selectedTab ? 'bg-white' : 'bg-gray-50 border-b border-gray-200'}
                            `}
                            onClick={() => setSelectedTab(tab.key)}
                        >
                            {tab.icon}
                            
                            <p className='text-base'>{tab.text}</p>

                            {tab.key === 'absent' && (
                                <p className='text-gray-600'>({groupAthleteAttendanceData.filter((athlete) => athlete.attendanceStatus === 'absent').length})</p>
                            )}

                            {tab.key === 'present' && (
                                <p className='text-gray-600'>({groupAthleteAttendanceData.filter((athlete) => athlete.attendanceStatus === 'present').length})</p>
                            )}

                            {tab.key === 'complete' && (
                                <p className='text-gray-600'>({groupAthleteAttendanceData.filter((athlete) => athlete.attendanceStatus === 'complete').length})</p>
                            )}
                        </div>
                    ))}
                </div>

                <div 
                    className={`
                        w-full divide-y divide-gray-200 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]
                        ${restrictHeight ? 'h-[60vh]' : 'min-h-[60vh]'}
                    `}
                >
                    {groupAthleteAttendanceData.filter((athlete) => athlete.attendanceStatus === selectedTab).length === 0 && (
                        <div className='text-center text-gray-500 py-12 select-none'>No athletes found</div>
                    )}

                    {groupAthleteAttendanceData
                    .filter((athlete) => athlete.attendanceStatus === selectedTab)
                    .map((athlete) => (
                        <div 
                            key={athlete.id}
                            className='flex items-center cursor-pointer'
                            
                        >

                            {/* Right Side */}

                            <div 
                                className='p-4 flex items-center gap-x-4'
                                onClick={() => ViewAthleteProfileInNewTab(athlete.id)}
                            >
                                <UserProfilePicture firstName={athlete.firstName} lastName={athlete.lastName} shadow={false} />

                                <div className='flex-grow text-left select-none'>
                                    <p className='text-lg'>{athlete.firstName} {athlete.lastName}</p>
                                    <p className='text-sm text-gray-500'>View Profile</p>
                                </div>
                            </div>

                            {/* Left Side */}

                            <div 
                                className='py-[30px] pr-4 flex-1 flex items-center justify-end'
                                onClick={() => ToggleAthleteAttendanceStatus(athlete.id)}
                            >
                                {/* <p className='text-sm text-gray-500'>{athlete.attendanceStatus}</p> */}

                                {athlete.attendanceStatus === 'present' && (
                                    <p className='text-sm text-gray-500 pr-4 select-none'>Remove</p>
                                )}

                                {athlete.attendanceStatus === 'absent' && (
                                    <p className='text-sm text-gray-500 pr-4 select-none'>Add</p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

                <div 
                    className='w-full flex items-center justify-center gap-x-2 p-4 border-t border-gray-200 cursor-pointer'
                    onClick={() => setRestrictHeight(!restrictHeight)}
                >
                    {restrictHeight && <ChevronDownIcon className='h-6 w-6 text-gray-500' />}
                    {!restrictHeight && <ChevronUpIcon className='h-6 w-6 text-gray-500' />}
                </div>
            </ContentFrame>
        </div>
    )
}